import styled from 'styled-components';

import hairBg from '../../assets/hair.svg';
import media from '../../styles/media.style';
import { BG_GRAY, MOBILE_PADDING, PAGE_WIDTH, SCREEN_LOCKUP_WIDTH } from '../../styles/variables.style';

export const Section = styled.section`
  padding: 30px ${MOBILE_PADDING}px;
  background: center / cover no-repeat url(${hairBg}), ${BG_GRAY.COMMON_1};
  margin: auto;
  max-width: ${PAGE_WIDTH}px;
  width: 100%;

  ${media.tabletL`
  padding: 100px 0;
`};
`;

export const Inner = styled.div`
  margin: auto;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  width: 100%;
`;

export const Title = styled.div`
  font-size: 26px;
  font-weight: 600;
  line-height: 1.15;
  letter-spacing: 0.6px;
  text-align: center;

  ${media.tabletL`
  font-size: 48px;
  font-weight: 500;
  line-height: 1;
`};
`;

export const Description = styled.div`
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.1px;
  margin: 30px auto 0;
  max-width: 600px;
  text-align: center;
  a {
    text-decoration: underline;
  }
`;

export const List = styled.div`
  margin-top: 30px;

  ${media.tabletL`
  margin-top: 70px;
`};
`;

export const Labels = styled.div`
  display: none;

  ${media.tabletL`
  border-bottom: 1px solid black;
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
`};
`;

export const Item = styled.div`
  border-bottom: 1px solid #9b9b9b;
  padding: 40px 0;

  &:last-child {
    border-bottom: none;
  }

  ${media.tabletL`
    display: flex;
    justify-content: space-around;
  `};
`;

export const Region = styled.div`
  align-items: center;
  display: flex;
  font-size: 24px;
  font-weight: 500;
  justify-content: center;
  line-height: 0.58;
  letter-spacing: 0.2px;

  ${media.tabletL`
  text-align: left;
  width: 15%;
  line-height: 30px;
`};
`;

export const Address = styled.div`
  display: flex;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.1px;
  margin-top: 15px;
  white-space: pre-wrap;

  ${media.tabletL`
  margin-top: 0;
  width: 25%;
`};
`;

export const Email = Address;

export const Phone = Address.extend`
  ${media.tabletL`
  width: 20%;
`};
`;



// WEBPACK FOOTER //
// ./src/pages/ContactUsPage/ContactUsPage.style.js